import { useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { getMotionTier, shouldAnimateMotion } from '@/lib/motion-effects';
import { navRouteIndex, slideEnterClass } from '@/lib/motion';
import { cn } from '@/lib/utils';

/** Route outlet with horizontal slide between nav tabs and within-tab navigation. */
export function AnimatedOutlet() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const prevIndex = useRef(navRouteIndex(location.pathname));

  const currentIndex = navRouteIndex(location.pathname);
  const spring = shouldAnimateMotion(getMotionTier()) && getMotionTier() === 'arcade';
  let enterClass = slideEnterClass(prevIndex.current, currentIndex, spring);

  if (currentIndex === prevIndex.current && location.pathname !== prevPath.current) {
    enterClass =
      location.pathname.length >= prevPath.current.length
        ? slideEnterClass(prevIndex.current, currentIndex + 1, spring)
        : slideEnterClass(currentIndex + 1, prevIndex.current, spring);
  }

  prevIndex.current = currentIndex;
  prevPath.current = location.pathname;

  return (
    <div key={location.pathname} className={cn(enterClass, 'min-h-[40vh]')}>
      <Outlet />
    </div>
  );
}
